import React from 'react';
import './GymIcon.css';

function GymIcon({ className = '' }) {
  const classes = ['gym-icon', className].filter(Boolean).join(' ');

  return (
    <span className={classes} aria-hidden="true">
      <span className="gym-icon-plate gym-icon-plate-left" />
      <span className="gym-icon-grip" />
      <span className="gym-icon-bar" />
      <span className="gym-icon-grip" />
      <span className="gym-icon-plate gym-icon-plate-right" />
    </span>
  );
}

export default GymIcon;
